class GoogleMap extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.setupListeners()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.els?.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })
  }

  handleTrigger (event) {
    const currentElement = event.currentTarget
    const controlValue = currentElement.dataset.control

    this.els?.trigger?.elements.forEach((triggerEl) =>
      triggerEl.setAttribute(
        'aria-pressed',
        triggerEl === currentElement ? 'true' : 'false',
      ),
    )

    this.els?.container?.elements.forEach((containerEl) =>
      containerEl.setAttribute(
        'aria-hidden',
        containerEl.dataset.type === controlValue ? 'false' : 'true',
      ),
    )
  }
}

if (!customElements.get('google-map')) {
  customElements.define('google-map', GoogleMap)
}
